<template>
  <div class="map-container">
    <div
      ref="mapContainer"
      class="map"
    />
    <slot name="footer" />
  </div>
</template>

<script>
import {defineComponent} from 'vue';
import {useI18n} from 'vue-i18n';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default defineComponent({
  name: 'HitMap',
  props: {
    title: {
      type: String,
      default: null,
    },
    position: {
      type: Object,
      required: false,
      default: () => ({
        type: 'Point',
        coordinates: [0.000000, 0.000000],
      }),
    },
  },
  setup() {
    const {t} = useI18n();
    return {t};
  },
  emits: ['update:location'],
  data() {
    return {
      map: null,
      marker: null,
    };
  },
  watch: {
    position: {
      handler(newPos) {
        if (this.marker && this.map) {
          const [lng, lat] = newPos.coordinates;
          this.marker.setLatLng([lat, lng]);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      L.Icon.Default.mergeOptions({
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      });

      const [lng, lat] = this.position.coordinates;

      const mapContainer = this.$refs.mapContainer;
      if (!mapContainer) return;

      this.map = L.map(mapContainer).setView([lat, lng], 16);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors',
      }).addTo(this.map);

      this.marker = L.marker([lat, lng], {
        draggable: true,
      }).addTo(this.map);

      this.map.on('click', (e) => {
        const pos = e.latlng;
        this.updatePosition(pos);
      });

      this.marker.on('dragend', (e) => {
        const pos = e.target.getLatLng();
        this.updatePosition(pos);
      });
    },
    updatePosition({lat, lng}) {
      const newPosition = {
        type: 'Point',
        coordinates: [lng, lat],
      };

      this.$emit('update:location', newPosition);
    },
    centerMap(lat, lng) {
      if (this.map) {
        this.map.setView([lat, lng], 16);

        if (this.marker) {
          this.marker.setLatLng([lat, lng]);
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.map-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 600px;
}

.map {
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
